var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * 小头像选择框-生小孩专用
 * 调用后端接口处理人脸，自动居中
 */
import React, { useRef, useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import H5CommonComponent from '@tencent/h5-common-component';
// 为何编译报错 todo
// import { ImageSourceType } from '@tencent/h5-common-component/dist/src/image-picker/base';
import { getFaceNumber } from '../../../lib/utils/fetch-data';
import Modal from '../Modal';
import style from './index.module.scss';
import { ERROR_CODE_MAPPING } from '../../../components/H5ChristmasIndexPage/h5-config';
import ImageCropper from '../ImageCropper';
import { computeFaceInfo } from '../../utils/face-detect';
const DEFAULT_FEEDBACK_MSG = '当前体验人数较多, 请稍后再试吧~';
const TinyChooseImageArea = ({ backgroundImage, chooseList, handleChooseImage, chooseImageMask, isAutoDetectFace = true, outerImage, loadingUrl, isCanbeDrag, faceAreaRatio = 0.3, getFaceInfo, }, ref) => {
    const [isChoosed, setChooseStatus] = useState(false);
    const [croppedImage, setCroppedImage] = useState('');
    const [chooseImageBase64, setChooseImage] = useState('');
    // 给裁图组件使用的图片
    const [cropImageBase64, setCropImageBase64] = useState('');
    const [isModalShow, setModalStatus] = useState(false);
    const [feedbackMsg, setFeedbackMsg] = useState(DEFAULT_FEEDBACK_MSG);
    const [isShowLoading, setLoadingStatus] = useState(false);
    const [isShowErrorModal, setErrorModalStatus] = useState(false);
    const [isSuccessGetFaceInfo, setGetFaceInfoStatus] = useState(false);
    const cropRef = useRef(null);
    const [autoCropLocation, setAutoCropLocation] = useState(null);
    useEffect(() => {
        if (isSuccessGetFaceInfo && chooseImageBase64) {
            setCropImageBase64(chooseImageBase64);
            setChooseStatus(true);
        }
    }, [isSuccessGetFaceInfo]);
    useEffect(() => {
        setGetFaceInfoStatus(false);
        if (!chooseImageBase64) {
            return;
        }
        const getCroppedImage = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            setLoadingStatus(true);
            const res = yield getFaceNumber(chooseImageBase64.split(',')[1].trim());
            const code = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code;
            if (code !== 0) {
                setLoadingStatus(false);
                const errMsg = ERROR_CODE_MAPPING[code]
                    ? ERROR_CODE_MAPPING[code].msg
                    : '活动太火爆了，请稍后再试';
                setFeedbackMsg(errMsg);
                setErrorModalStatus(true);
                return;
            }
            const { data } = res;
            const extraInfo = JSON.parse(data.extra);
            const faceInfo = yield computeFaceInfo(extraInfo, chooseImageBase64, faceAreaRatio);
            setAutoCropLocation(faceInfo);
            if (!isAutoDetectFace) {
                getFaceInfo === null || getFaceInfo === void 0 ? void 0 : getFaceInfo(faceInfo);
                handleChooseImage === null || handleChooseImage === void 0 ? void 0 : handleChooseImage(chooseImageBase64);
                return;
            }
            handleChooseImage === null || handleChooseImage === void 0 ? void 0 : handleChooseImage(chooseImageBase64);
            setLoadingStatus(false);
            setGetFaceInfoStatus(true);
        });
        getCroppedImage();
    }, [chooseImageBase64]);
    useEffect(() => {
        if (!outerImage) {
            return;
        }
        setCroppedImage(outerImage);
        setChooseStatus(true);
    }, [outerImage]);
    const handleClickChooseBtn = (type) => {
        const imagePickerInstance = new H5CommonComponent.ImagePickerEnhance(false, undefined, false);
        imagePickerInstance.chooseImage(img => {
            setChooseImage(img);
            setModalStatus(false);
        }, type);
    };
    /**
     * 模态框内容-暂时不要了
     */
    const getModalContent = () => (React.createElement("div", { className: style['modal-content'] },
        React.createElement("div", { className: style.operate },
            React.createElement("div", { className: style.album, onClick: () => handleClickChooseBtn(0) }, "\u4ECE\u76F8\u518C\u4E2D\u4E0A\u4F20"),
            React.createElement("div", { className: style.camera, onClick: () => handleClickChooseBtn(1) }, "\u62CD\u7167")),
        React.createElement("div", { className: style.choose }, chooseList &&
            chooseList.map(item => (React.createElement("div", { className: style.chooseWrapper, key: item.text },
                React.createElement("img", { className: style.icon, src: item.thumbUrl }),
                React.createElement("span", null, item.text)))))));
    const handleSelectedBtn = () => {
        const pickerInstance = new H5CommonComponent.ImagePickerEnhance(true, 0, true);
        pickerInstance.chooseImage(img => {
            setChooseImage(img);
        });
    };
    const getLoadingContent = () => (React.createElement("div", { className: style['loading-modal'] },
        React.createElement("img", { src: loadingUrl, alt: "" })));
    const getErrorModalContent = () => (React.createElement("div", { className: style['feedback-modal'] },
        React.createElement("div", { className: style['feedback-modal-title'] }, feedbackMsg),
        React.createElement("div", { className: style['feedback-modal-action-btn'], onClick: () => {
                setErrorModalStatus(false);
            } }, "\u597D\u7684")));
    useImperativeHandle(ref, () => ({
        getImageBase64: () => {
            var _a;
            return (_a = cropRef.current) === null || _a === void 0 ? void 0 : _a.getImageData();
        },
    }));
    return (React.createElement("div", { className: style['tiny-choose-image-container'] },
        React.createElement("div", { className: style['image-container'] },
            React.createElement("div", { className: style.selected, style: { backgroundImage: `url(${isChoosed ? chooseImageMask : backgroundImage})` }, onClick: handleSelectedBtn, "data-btn-id": "choose_image#choose" }),
            isChoosed ? (React.createElement(React.Fragment, null, isCanbeDrag && cropImageBase64 ? (React.createElement("div", { className: style['crop-container'] },
                React.createElement(ImageCropper, { ratio: 1, imgBase64: cropImageBase64, autoCropArea: 1, resultImgSize: 720, viewMode: 1, maskImgUrl: '', autoCropLocation: autoCropLocation, isNeedFixedCrop: false, ref: cropRef, minContainerWidth: 155 }))) : (React.createElement("img", { className: style['cropped-image'], src: croppedImage, alt: "alt" })))) : null),
        React.createElement(Modal, { content: getLoadingContent(), visible: isShowLoading, hideModal: () => setLoadingStatus(false) }),
        React.createElement(Modal, { content: getErrorModalContent(), visible: isShowErrorModal, hideModal: () => {
                setErrorModalStatus(false);
            } })));
};
export default forwardRef(TinyChooseImageArea);
